import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const sizeMap = { sm: '1rem', md: '2rem', lg: '3rem' } as const;
const borderMap = { sm: '0.125rem', md: '0.1875rem', lg: '0.25rem' } as const;

export const SpinnerWrapper = styled.div<{ $size: 'sm' | 'md' | 'lg' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme, $size }) =>
    $size === 'sm' ? theme.spacing[2] : theme.spacing[8]};
`;

export const Circle = styled.div<{ $size: 'sm' | 'md' | 'lg' }>`
  width: ${({ $size }) => sizeMap[$size]};
  height: ${({ $size }) => sizeMap[$size]};
  border: ${({ $size }) => borderMap[$size]}
    solid ${({ theme }) => theme.colors.gray200};
  border-top-color: ${({ theme }) => theme.colors.accent};
  border-radius: 50%;
  animation: ${spin} 0.7s cubic-bezier(0.4, 0, 0.2, 1) infinite;
`;
